import { Bundle } from "../types";
import { useUserData } from "./useUserData";

// Function overloads for proper type inference
export function useBundlePricing(bundle: Bundle): {
  priceToUse: any;
  price: number;
  discountedPrice: number;
  discountPercentage: number;
  hasDiscount: boolean;
  userIsGold: boolean | undefined;
};
export function useBundlePricing(bundle: Bundle | null | undefined): {
  priceToUse: any | null;
  price: number;
  discountedPrice: number;
  discountPercentage: number;
  hasDiscount: boolean;
  userIsGold: boolean | undefined;
};
export function useBundlePricing(bundle: Bundle | null | undefined) {
  const { userData } = useUserData();
  const userIsGold = userData?.gold;

  // Return null values when bundle is not provided
  if (!bundle) {
    return {
      priceToUse: null,
      price: 0,
      discountedPrice: 0,
      discountPercentage: 0,
      hasDiscount: false,
      userIsGold,
    };
  }

  // Choose which price to use based on user gold status
  const priceToUse = (userIsGold ? bundle.gold_price : bundle.price) ?? null;

  if (!priceToUse) {
    return {
      priceToUse: null,
      price: 0,
      discountedPrice: 0,
      discountPercentage: 0,
      hasDiscount: false,
      userIsGold,
    };
  }

  const { price_float: price, price_float_discounted: discountedPrice } =
    priceToUse;

  // Calculate discount percentage
  const discountPercentage = Math.round(
    ((price - (discountedPrice ?? 0)) / price) * 100,
  );

  const hasDiscount = discountPercentage > 0;

  return {
    priceToUse,
    price,
    discountedPrice,
    discountPercentage,
    hasDiscount,
    userIsGold,
  };
}